function keyMirror (obj) {
  if (obj instanceof Object) {
    var _obj = Object.assign({}, obj)
    var _keyArray = Object.keys(obj)
    _keyArray.forEach(key => {
      _obj[key] = key
    })
    return _obj
  }
}

export default keyMirror({
  'CHANGE_PROFILE': null,
  'CHANGE_SUB_ANSWER': null,
  'CHANGE_QUESTION': null,
  'CHANGE_QUESTIONS': null,
  'CHANGEING_QUESTIONS': null,
  'CHANGE_QUESTIONS_LIST': null,
  'CHANGE_QUESTION_INDEX': null,
  'CHANGE_SUBQUESTION_INDEX': null,
  'CHANGE_SKILLTREE': null,
  'CHANGE_COURSE': null,
  'UPDATE_QUESTIONS_LIST': null,
  'CHANGE_SKILLTREE_STATUS': null,
  'CHANGE_ANSWER_INVALID': null,
  'CLEAR_QUESTION': null,
  'CHANGE_SUBMIT_STATUS': null,
  'CHANGE_PUBLISH_STATUS': null
})
